import React, { Fragment } from "react";
import { useDraggableSheet } from "../../../helpers/hooks";
import { useDispatch, useSelector } from "react-redux";
import { fetchSaveUnSaveCreation, saveUnSaveCreation } from "../../Reducers/actions/creationsActions";
import Icon from "../Icon/Icon";
import './EditCreation.scss'

const EditCreation = ({ creation, onClose, onDelete, onEdit }) => {

    const { creations, user_id } = useSelector(state => ({
        creations: state.creation.creations,
        user_id: state.auth?.user?.user_id
    }))

    const {
        sheetStyle,
        overlayHandlers,
    } = useDraggableSheet({ onClose });

    const dispatch = useDispatch()

    const handleSaveUnsave = () => {
        const unsave = creation?.is_saved?.length > 0;

        fetchSaveUnSaveCreation(creation.creation_id, unsave)
            .then(() => { })
            .catch((err) => {
                console.error("Error saving/unsaving: ", err);
            });
        dispatch(
            saveUnSaveCreation(
                creation.creation_id,
                !unsave,
            )
        );
    };

    return (
        <div className="edit-container" {...overlayHandlers}>
            <div className="sheet px-16" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
                {/* <span className="pull-bar"></span> */}
                <span
                    className="d-flex mt-40 pb-24 mb-24 fg-crea edit-item"
                    onClick={() => handleSaveUnsave()}
                >
                    {!creation?.is_saved?.length ? (
                        <Fragment>
                            <Icon alias={"save"} color="#282828" width={24} className="mr-12" />
                            Save
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Icon alias={"unsave"} color="#282828" width={24} className="mr-12" />
                            Unsave
                        </Fragment>
                    )}
                    <Icon alias={"chevron-right"} width={24} color="#999999" className={"ml-auto"} />
                </span>
                <span
                    className="d-flex pb-24 mb-24 edit-item fg-crea"
                    onClick={() => onEdit()}
                >
                    <Icon alias={"edit"} width={24} color="#282828" className={"mr-12"} />
                    Edit
                    <Icon alias={"chevron-right"} width={24} color="#999999" className={"ml-auto"} />
                </span>
                <span
                    className="d-flex pb-24 mb-24 fg-red-pink"
                    onClick={() => onDelete()}
                >
                    <Icon alias={"delete"} width={24} stroke="#FF3232" color="transparent" className={"mr-12"} />
                    Delete
                    <Icon alias={"chevron-right"} width={24} color="#999999" className={"ml-auto"} />
                </span>
            </div>
        </div>
    )
}

export default EditCreation